import React from 'react';
import CustomButton from '../customButton';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import adminCardCss from './adminVerkstedCard.module.css';

export function AdminVerkstedCard({ verksted}) {
    console.log(verksted);
    const id = verksted.id;
    const title = verksted.attributes.username;
    const image = verksted.attributes.image.data.attributes.url;


    return(
            <div className={adminCardCss.adminVerkstedCard}>
                <Link to={`/admin/verksted/${id}`}>
                <div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 m-auto">
                                <Image className={adminCardCss.image} src={image} fluid alt={title}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col text-center">
                                <p className={adminCardCss.pTitle}>{title}</p>
                            </div>
                        </div>
                    </div>
                </div>
                    <CustomButton 
                        label="Oversikt"
                        className={`${adminCardCss.loginButton} login-button text-white my-3`}
                    />
                </Link> 
            </div>
    )
}

export default AdminVerkstedCard;